module.exports = __webpack_public_path__ + "img/th_7mm_Agg_T.c88678ac.jpg";